<script setup lang="ts">
import DRMenu from "@/components/UI/menu/DRMenu.vue";
import ProjectsMenu from "@/components/projects/ProjectsMenu.vue";
import OfflineIndicator from "@/components/files/OfflineIndicator.vue";
import { MenuType, type MenuEntity } from "@/components/UI/menu/menu.types";
import { PagesIndex } from "@/utils/menu.utils";
import { computed } from "vue";
import { useDrawingStore } from "@/stores/fileStore";

withDefaults(
  defineProps<{
    minimal?: boolean;
  }>(),
  {
    minimal: undefined,
  }
);

const drawingStore = useDrawingStore();

const unsyncCount = computed(() => drawingStore.unsyncCount);
const erroredCount = computed(() => drawingStore.erroredCount);

const topMenu: MenuEntity[] = [
  {
    type: MenuType.LINK,
    icon: "house",
    label: "dashboard:navigation.home",
    route: { name: "home" },
    index: PagesIndex.HOME,
  },
  {
    type: MenuType.LINK,
    icon: "folder",
    label: "dashboard:navigation.projects",
    route: { name: "projects" },
    index: PagesIndex.PROJECTS,
  },
  {
    type: MenuType.LINK,
    icon: "building",
    label: "dashboard:navigation.organization-page",
    route: { name: "settings" },
    index: "settings",
    matchChildRoutes: true,
  },
];

const bottomMenu = computed(() => {
  const menu: MenuEntity[] = [
    {
      type: MenuType.LINK,
      icon: "archive",
      label: "dashboard:navigation.archived-plans",
      route: { name: "archives" },
      index: PagesIndex.ARCHIVES,
    },
  ];
  if (erroredCount.value || !!unsyncCount.value) {
    menu.push({
      type: MenuType.LINK,
      icon: "cloud-slash",
      label: "dashboard:navigation.synchronization-issues",
      route: { name: "synchronization-issues" },
      index: PagesIndex.SYNC_ISSUES,
      highlight: erroredCount.value
        ? {
            value: erroredCount.value,
            color: "danger",
          }
        : {
            value: unsyncCount.value,
            color: "warning",
          },
    });
  }
  return menu;
});
</script>

<template>
  <div class="navigation-content d-flex flex-column h-100">
    <el-scrollbar class="flex-grow-1">
      <DRMenu :menu="topMenu" :minimal="minimal" class="px-2 pt-2" />
      <ProjectsMenu :minimal="minimal" class="px-2" />
    </el-scrollbar>

    <OfflineIndicator :minimal="minimal" />

    <DRMenu :menu="bottomMenu" :minimal="minimal" class="p-2" />
  </div>
</template>
